import { ReleaseNoteSectionViewOf } from 'bff';
import { InlineText } from '../RichText';

export const StepNumber = ({ number }: { number: number }) => (
  <span className='flex h-[1.375rem] w-[1.375rem] shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold tabular-nums text-primary-foreground'>
    {number}
  </span>
);

// One box split in steps: stacked on a phone, side by side once there is room.
export const StepsSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'steps'>;
}) => (
  <ol className='grid overflow-hidden rounded border border-stone-200 bg-white md:auto-cols-fr md:grid-flow-col'>
    {content.steps.map((step, index) => (
      <li
        key={index}
        className='flex gap-3 border-b border-stone-100 p-4 last:border-b-0 md:flex-col md:border-b-0 md:border-r md:last:border-r-0'
      >
        <StepNumber number={index + 1} />
        <div className='flex flex-col gap-1'>
          <p className='text-sm font-semibold text-foreground'>{step.title}</p>
          <p className='text-[0.8125rem] leading-relaxed text-stone-600'>
            <InlineText text={step.body} />
          </p>
        </div>
      </li>
    ))}
  </ol>
);
